"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tokens_1 = __importDefault(require("@paprika/tokens"));
var ProjectsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ProjectsLogo"));
var Notebook_1 = __importDefault(require("@acl-services/wasabicons/lib/Notebook"));
var Target_1 = __importDefault(require("@acl-services/wasabicons/lib/Target"));
var ClockPlus_1 = __importDefault(require("@acl-services/wasabicons/lib/ClockPlus"));
var MissionControl_1 = __importDefault(require("@acl-services/wasabicons/lib/MissionControl"));
var ReportsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ReportsLogo"));
var ClipboardCheck_1 = __importDefault(require("@acl-services/wasabicons/lib/ClipboardCheck"));
var ResultsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ResultsLogo"));
var ChartArrow_1 = __importDefault(require("@acl-services/wasabicons/lib/ChartArrow"));
var Robot_1 = __importDefault(require("@acl-services/wasabicons/lib/Robot"));
var AnalyticsLogoCircle_1 = __importDefault(require("@acl-services/wasabicons/lib/AnalyticsLogoCircle"));
var StrategyLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/StrategyLogo"));
var Flowchart_1 = __importDefault(require("@acl-services/wasabicons/lib/Flowchart"));
var Clipboard_1 = __importDefault(require("@acl-services/wasabicons/lib/Clipboard"));
var FileAdd_1 = __importDefault(require("@acl-services/wasabicons/lib/FileAdd"));
var TimeAndDate_1 = __importDefault(require("@acl-services/wasabicons/lib/TimeAndDate"));
var Placeholder_1 = __importDefault(require("@acl-services/wasabicons/lib/Placeholder"));
var AssetTypes_1 = __importDefault(require("@acl-services/wasabicons/lib/AssetTypes"));
var ActivityCenter_1 = __importDefault(require("@acl-services/wasabicons/lib/ActivityCenter"));
var customEggplantColor = '#F6F0FA';
var appData = [
    {
        key: 'workspace',
        apps: [
            {
                backgroundColor: customEggplantColor,
                icon: AssetTypes_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'asset_inventory',
            },
            {
                backgroundColor: customEggplantColor,
                icon: ProjectsLogo_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'projects',
            },
            {
                backgroundColor: customEggplantColor,
                icon: Notebook_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'issue_tracker',
            },
            {
                backgroundColor: customEggplantColor,
                icon: Target_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'task_tracker',
            },
            {
                backgroundColor: customEggplantColor,
                icon: ClockPlus_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'project_timesheets',
            },
            {
                backgroundColor: customEggplantColor,
                icon: MissionControl_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'mission_control',
            },
            {
                backgroundColor: customEggplantColor,
                icon: ReportsLogo_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'reports',
            },
            {
                backgroundColor: customEggplantColor,
                icon: ClipboardCheck_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'policy_training',
            },
            {
                backgroundColor: customEggplantColor,
                icon: ActivityCenter_1.default,
                iconColor: tokens_1.default.color.eggplantLighten30,
                key: 'activity_center',
            },
        ],
    },
    {
        key: 'automation',
        apps: [
            {
                backgroundColor: tokens_1.default.color.blueLighten50,
                icon: ResultsLogo_1.default,
                iconColor: tokens_1.default.color.blueDarken10,
                key: 'results',
            },
            {
                backgroundColor: tokens_1.default.color.blueLighten50,
                icon: ChartArrow_1.default,
                iconColor: tokens_1.default.color.blueDarken10,
                key: 'storyboards',
            },
            {
                backgroundColor: tokens_1.default.color.blueLighten50,
                icon: Robot_1.default,
                iconColor: tokens_1.default.color.blueDarken10,
                key: 'robots',
            },
            {
                backgroundColor: tokens_1.default.color.blackLighten70,
                icon: AnalyticsLogoCircle_1.default,
                iconColor: tokens_1.default.color.blackLighten10,
                key: 'analytics',
            },
        ],
    },
    {
        key: 'setup',
        apps: [
            {
                backgroundColor: tokens_1.default.color.greenLighten50,
                icon: StrategyLogo_1.default,
                iconColor: tokens_1.default.color.green,
                key: 'strategy',
            },
            {
                backgroundColor: tokens_1.default.color.greenLighten50,
                icon: Flowchart_1.default,
                iconColor: tokens_1.default.color.green,
                key: 'frameworks',
            },
            {
                backgroundColor: tokens_1.default.color.greenLighten50,
                icon: Clipboard_1.default,
                iconColor: tokens_1.default.color.green,
                key: 'compliance_maps',
            },
            {
                backgroundColor: tokens_1.default.color.greenLighten50,
                icon: FileAdd_1.default,
                iconColor: tokens_1.default.color.green,
                key: 'assurance_plans',
            },
            {
                backgroundColor: tokens_1.default.color.greenLighten50,
                icon: TimeAndDate_1.default,
                iconColor: tokens_1.default.color.green,
                key: 'project_scheduler',
            },
            {
                backgroundColor: tokens_1.default.color.greenLighten50,
                icon: Placeholder_1.default,
                iconColor: tokens_1.default.color.green,
                key: 'master_library',
            },
        ],
    },
];
exports.default = appData;
//# sourceMappingURL=appData.js.map